import type { Theme } from '@mui/material/styles';

import { MuiColors } from '../../theme/types';
import { FTButtonVariants, MuiButtonVariants } from './types';

export const hoverBackground = (
  variant: FTButtonVariants,
  theme: Theme,
): string => {
  switch (variant) {
    case 'main':
      return theme.palette.colors.purple[600];
    case 'secondary':
      return theme.palette.colors.purple[200];
    case 'danger':
      return theme.palette.colors.red[600];
    default:
      return theme.palette.colors.purple[100];
  }
};

export const borderColor = (
  variant: FTButtonVariants,
  theme: Theme,
): string => {
  switch (variant) {
    case 'main':
      return theme.palette.colors.purple[300];
    case 'secondary':
      return theme.palette.colors.purple[400];
    case 'danger':
      return theme.palette.colors.red[300];
    default:
      return theme.palette.colors.purple[100];
  }
};

export const FTVariantMuiColorMap: Record<FTButtonVariants, MuiColors> = {
  danger: 'error',
  ghost: 'primary',
  main: 'primary',
  secondary: 'secondary',
};

export const FTMuiButtonVariantMap: Record<
  FTButtonVariants,
  MuiButtonVariants
> = {
  danger: 'contained',
  ghost: 'text',
  main: 'contained',
  secondary: 'contained',
};

export const getFTVariantLoadingIconColorMap = (
  theme: Theme,
): Record<FTButtonVariants, string> => ({
  danger: theme.palette.colors.white,
  ghost: theme.palette.colors.purple[500],
  main: theme.palette.colors.white,
  secondary: theme.palette.colors.purple[500],
});
